/* eslint-disable import/no-relative-packages */
/* eslint-disable no-param-reassign */
/* eslint-disable no-new */
/* eslint-disable import/prefer-default-export */
import * as d3 from 'd3'

const { guff } = require('bam-node-baseball-savant/utils/guff')

const BALL_COLOR = 'blue'
const STRIKE_COLOR = 'red'

const idMap = {
    catcher: 'fielder_2',
    pitcher: 'pitcher',
    batter: 'savant_batter_id',
    'catching-team': 'fld_team_id',
    'batting-team': 'bat_team_id',
}

export function plotPitches(svgId, playerId, pitchData, opts = {}) {
    const thresholds = {
        maxThreshold: 2.0,
        minThreshold: 2.0,
        filterNonK: false,
        filterNonBB: false,
        ...opts,
    }

    const zoneWidth = 150.94
    const zoneHeight = 180

    const chart = d3.select(`#zone_chart_${playerId}`)

    const xScale = d3
        .scaleLinear()
        .domain([0, 1])
        .range([0, zoneWidth / 2])

    const yScale = d3
        .scaleLinear()
        .domain([0, 1])
        .range([0, (zoneHeight / 2) * -1])

    chart
        .selectAll('circle')
        .data(
            pitchData
                .filter(
                    (d) =>
                        (d.edge_dist_calc > thresholds.maxThreshold &&
                            d.event_type === 'called_strike') ||
                        (d.edge_dist_calc < thresholds.minThreshold * -1 &&
                            d.event_type === 'ball')
                )
                .filter((d) => {
                    if (thresholds.filterNonK) {
                        if (isBall(d)) {
                            return true
                        }
                        return d.pre_strike_count === 2
                    }
                    return true
                })
                .filter((d) => {
                    if (thresholds.filterNonBB) {
                        if (d.event_type === 'called_strike') {
                            return true
                        }
                        return d.pre_ball_count === 3
                    }
                    return true
                })
        )
        .join((enter) => {
            const linkWrap = enter
                .append('a')
                .attr('href', (d) => `/sporty-videos?playId=${d.play_id}`)
                .attr('target', '_blank')
                .attr('class', 'strike-zone-link')

            linkWrap
                .append('circle')
                .attr('cx', (d) => xScale(d.api_relative_plate_x))
                .attr('cy', (d) => yScale(d.api_relative_plate_z))
                .attr('r', 4.5)
                .attr('class', (d) => `strike-zone-dot-${d.id}`)
                .attr('id', (d) => `strike-zone-dot-${d.play_id}`)
                .attr('stroke', 'black')
                .attr('stroke-width', (d) => {
                    if (isTerminal(d)) {
                        return 3
                    }
                    return 1
                })
                .attr('fill', (d) => {
                    if (isBall(d)) {
                        return BALL_COLOR
                    }
                    return STRIKE_COLOR
                })
                .attr('fill-opacity', 0.5)
                .on('mouseover', (e, d) => {
                    d3.selectAll(`.strike-zone-dot-${d.id}`).attr(
                        'opacity',
                        0.2
                    )
                    d3.select(`#${e.target.id}`)
                        .attr('opacity', 1)
                        .attr('fill-opacity', 1)
                    displayInfoBox(d.id, d.play_id, d)
                })
                .on('mouseout', (e, d) => {
                    d3.selectAll(`.strike-zone-dot-${d.id}`)
                        .attr('opacity', 1)
                        .attr('fill-opacity', 0.5)
                    d3.selectAll(`.tooltip-${d.play_id}`).remove()
                })
        })
}

export function removePitches(playerId) {
    d3.selectAll(`.strike-zone-dot-${playerId}`).remove()
}

export function handleTableMouseOver(playerId, playId, datum) {
    if (!datum) {
        return
    }

    const thisDot = d3.select(`#strike-zone-dot-${playId}`)

    if (!thisDot.empty()) {
        d3.selectAll(`.strike-zone-dot-${playerId}`).attr('opacity', 0.2)
        thisDot.attr('opacity', 1).attr('fill-opacity', 1)
        displayInfoBox(playerId, playId, datum)
    }
}

export function handleTableMouseOff(playerId, playId) {
    const thisToolTip = d3.selectAll(`.tooltip-${playId}`)

    if (!thisToolTip.empty()) {
        d3.selectAll(`.strike-zone-dot-${playerId}`)
            .attr('opacity', 1)
            .attr('fill-opacity', 0.5)
        thisToolTip.remove()
    }
}

export function handleGroupedTableMouseOver(groupedType, activeId, groupedId) {
    let selected

    if (groupedType !== 'pitchtype') {
        selected = d3
            .selectAll(`.strike-zone-dot-${activeId}`)
            .filter((d) => Number(d[idMap[groupedType]]) === Number(groupedId))
    } else {
        selected = d3
            .selectAll(`.strike-zone-dot-${activeId}`)
            .filter((d) => d.api_pitch_type_group03 === groupedId)
    }

    if (!selected.empty()) {
        d3.selectAll(`.strike-zone-dot-${activeId}`).attr('opacity', 0.2)
        selected.attr('opacity', 1).attr('fill-opacity', 1)
    }
}

export function handleGroupedTableMouseOff(playerId) {
    d3.selectAll(`.strike-zone-dot-${playerId}`)
        .attr('opacity', 1)
        .attr('fill-opacity', 0.5)
}

function displayInfoBox(idNum, playId, d) {
    const chart = d3.select(`#zone_chart_${idNum}`)
    const elemX = d3.select(`#strike-zone-dot-${playId}`).attr('cx')
    const elemY = d3.select(`#strike-zone-dot-${playId}`).attr('cy')

    const TOOLTIP_WIDTH = isStrikeout(d) ? 75 : 45
    const TOOLTIP_HEIGHT = isTerminal(d) ? 37 : 20
    const TOOLTIP_BUFFER = 10

    chart
        .append('rect')
        .attr('x', elemX - TOOLTIP_WIDTH / 2)
        .attr('y', elemY - TOOLTIP_HEIGHT - TOOLTIP_BUFFER)
        .attr('width', TOOLTIP_WIDTH)
        .attr('height', TOOLTIP_HEIGHT)
        .attr('rx', 2)
        .attr('stroke', 'black')
        .attr('stroke-width', 2)
        .attr('fill', 'white')
        .attr('class', `tooltip-${playId}`)

    chart
        .append('text')
        // .text(
        //     `${
        //         d.catcher_framing_runs > 0 ? '+' : '-'
        //     }${d.catcher_framing_runs.toFixed(2)}`
        // )
        .text(formatCalledStrikeProb(d.called_strike_prob))
        .attr('x', elemX)
        .attr('y', elemY - TOOLTIP_BUFFER - 5)
        .attr('text-anchor', 'middle')
        .attr('stroke', 'black')
        .style('font-size', '14px')
        .attr('class', `tooltip-${playId}`)

    if (isTerminal(d)) {
        chart
            .append('text')
            .text(isStrikeout(d) ? 'STRIKEOUT' : 'WALK')
            .attr('x', elemX)
            .attr('y', elemY - TOOLTIP_BUFFER - 20)
            .attr('text-anchor', 'middle')
            .attr('stroke', isStrikeout(d) ? STRIKE_COLOR : BALL_COLOR)
            .style('font-size', '14px')
            .attr('class', `tooltip-${playId}`)
    }
}

function formatCalledStrikeProb(prob) {
    if (prob === 0) {
        return '< 0.1%'
    }
    if (Math.round(prob * 100) === 0) {
        return guff(prob, 'pitch_percent')
    }
    if (prob === 1) {
        return '> 99%'
    }
    return guff(prob, 'cs_percent')
}

function isBall(d) {
    return d.event_type === 'ball' || d.event_type === 'blocked_ball'
}

function isStrikeout(d) {
    return d.event_type === 'called_strike' && d.pre_strike_count === 2
}

function isWalk(d) {
    return isBall(d) && d.pre_ball_count === 3
}

function isTerminal(d) {
    return isStrikeout(d) || isWalk(d)
}
